import TableCreatorCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import { getBayphoneUserTableDefinitions, bayphoneUserQueries } from './BayphoneUserTableDefinitions'


class BayphoneUserTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "BayphoneUserTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, bayphoneUserQueries)

        tableCreator.setDescriptions(
            getBayphoneUserTableDefinitions(false)
        )

        return tableCreator
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(BayphoneUserTableCreator)

export default BayphoneUserTableCreator;
